export const UNITS = [
  "Kilogram (kg)", "Gram (g)", "Milligram (mg)", "Millilitre (ml)", "Litre (L)",
  "Piece / Each", "Dozen", "Quintal", "Metric tonne", "Packet", "Box", "Bottle",
  "Bag", "Bundle", "Tray", "Crate", "Can", "Pack",
];

export const BUSINESS_TYPES = [
  { value: "manufacturer", label: "Manufacturer", desc: "Produces or processes goods and supplies them to distributors or wholesalers." },
  { value: "distributor", label: "Distributor", desc: "Buys from manufacturers and distributes to wholesalers, retailers and other businesses." },
  { value: "wholesaler", label: "Wholesaler", desc: "Buys in bulk and resells in smaller quantities to retailers or other businesses." },
  { value: "retailer", label: "Other (Retailer)", desc: "Buys from suppliers and sells to end customers or businesses." },
];

export const BUSINESS_TYPE_LABELS = {
  manufacturer: "Manufacturer", distributor: "Distributor", wholesaler: "Wholesaler", retailer: "Retailer",
  vendor: "Manufacturer", restaurant: "Wholesaler",
};

export const LICENSE_BY_TYPE = {
  manufacturer: ["FSSAI Manufacturing", "Factory License", "GST", "Pollution Control (CTO)", "Drug Mfg License", "Other"],
  distributor: ["GST", "FSSAI Distribution", "Drug Distribution License", "Trade License", "Other"],
  wholesaler: ["GST", "FSSAI Wholesale", "Trade License", "APMC/Mandi License", "Other"],
  retailer: ["GST", "FSSAI Retail", "Shop & Establishment", "Trade License", "Other"],
};

export const LICENSE_TYPES = [
  "FSSAI Manufacturing", "Factory License", "GST", "Pollution Control (CTO)", "Drug Mfg License",
  "FSSAI Distribution", "Drug Distribution License", "Trade License",
  "FSSAI Wholesale", "APMC/Mandi License", "FSSAI Retail", "Shop & Establishment", "Other",
];

export const ORDER_TABS = [
  "All", "New Requests", "Modified", "Accepted", "Delivered", "Missed Delivery", "Declined",
];

export const SUGGESTED_CATEGORIES = [
  "Meat", "Vegetables", "Fruits", "Spices", "Dairy Products",
  "Grains and Pulses", "Cutlery", "Kitchen Supplies", "Beverages", "Other Supplies",
];
